import { useEffect, useRef, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/smart-leads/profile-tags`;

// Profile chips for the visible leads list; re-polls while the backend builds missing ones.
export const useLeadTags = (leads) => {
  const [tags, setTags] = useState({});
  const ids = leads.slice(0, 200).map((l) => l.id).join(",");
  const tries = useRef(0);
  useEffect(() => {
    if (!ids) return undefined;
    let t;
    tries.current = 0;
    const load = () => axios.post(API, { lead_ids: ids.split(",") }).then((r) => {
      setTags((x) => ({ ...x, ...r.data.tags }));
      if (r.data.pending?.length && tries.current++ < 6) t = setTimeout(load, 15000);
    }).catch(() => {});
    load();
    return () => clearTimeout(t);
  }, [ids]);
  return tags;
};
